import { render, staticRenderFns } from "./removeLeader.vue?vue&type=template&id=683f9dc2&scoped=true"
import script from "./removeLeader.vue?vue&type=script&lang=js"
export * from "./removeLeader.vue?vue&type=script&lang=js"
import style0 from "./removeLeader.vue?vue&type=style&index=0&id=683f9dc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683f9dc2",
  null
  
)

export default component.exports